import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import UserApi from '../../../../API/user/user-api';
import { addStaff } from '../../../../actions/staff';
import { TYPE_BUTTONS } from '../../../../constans';
import { NAVIGATION } from '../../../../routers/routes';
import PopUp from '../../../Basic/Blocks/PopUp';
import Row from '../../../Basic/Blocks/Row';
import Button from '../../../Basic/Buttons/Button';
import CheckButton from '../../../Basic/Buttons/Check';
import { H1 } from '../../../Basic/WrapsStyle';
import Text from '../../../Basic/WrapsStyle/Text';
import styles from './styles.module.scss';


const AccessUserPopUp = ({ user = {}, close = () => { } }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({});

  const clickChange = () => {
    UserApi.changeUser({ data: { login: user.login, data: { accesses: data } } })
      .then(() => {
        UserApi.getAllUsers({}).then(r => dispatch(addStaff(r.users)))
        close();
      })
      .catch();
  };

  useEffect(() => {
    setData(user.accesses);
    console.log('user.accesses',user.accesses)
  }, [user]);


  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H1 style={{ marginBottom: '50px' }}>Настройка доступов для {user.name}</H1>

      <div className={styles.block}>
        {Object.values(NAVIGATION)
        .filter(nav => nav.routes.some(r => !r.isNotHeaderPage))
        .map((accessesByService) => {
          return (
            <div style={{width: '200px'}} key={accessesByService.rootUrl}>
              <Text fontSize={'20px'} fontWeight='bold' style={{ marginRight: '15px', marginBottom: '10px' }}>
                {accessesByService.text}</Text>
              {accessesByService.routes
              // .filter(r => !r.isNotHeaderPage)
              .map(access => {
                return (
                  <Row style={{ marginBottom: '1px' }} key={access.path}>
                    <Text fontSize={16} style={{ marginRight: '20px', width: '100%' }}>
                      {access.name}
                    </Text>
                    <CheckButton
                      checked={data?.[accessesByService.rootUrl]?.[access.path]}
                      onSelect={() => setData({ ...data, [`${accessesByService.rootUrl}`]: { ...data?.[`${accessesByService.rootUrl}`], [`${access.path}`]: !data?.[accessesByService.rootUrl]?.[access.path] } })}
                    />
                  </Row>
                )
              })}
              <div style={{ marginBottom: '30px' }}></div>

            </div>
          )

        })}
      </div>

      <Row style={{ marginTop: '30px' }}>
        <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={clickChange}>
          Сохранить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default AccessUserPopUp;
